import React, { useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { Shuffle, MoreVertical, Sparkles, MapPin, ShoppingBag } from 'lucide-react';

import { SafetyProvider } from './components/SafetyContext';
import { SafetyGate } from './components/SafetyOverlays';
import BottomNav from './components/BottomNav';
import CreateModal from './components/CreateModal';
import HomeFeed from './components/HomeFeed';
import Moments from './components/Moments';
import Chats from './components/Chats';
import ChatConversation from './components/ChatConversation';
import Alerts from './components/Alerts';
import Profile from './components/Profile';
import Shop from './components/Shop';
import Places from './components/Places';

function TopBar() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  if (pathname.startsWith('/chats/') || pathname === '/profile') return null;

  if (pathname === '/') {
    return (
      <header className="shrink-0 flex items-center justify-between px-4 py-3 bg-[#0a0f18] border-b border-[#141c28]">
        <span className="font-brand text-2xl text-white leading-none pt-1">Momos</span>
        <div className="flex items-center gap-2">
          <button onClick={() => navigate('/places')} className="w-9 h-9 rounded-full bg-[#141c28] flex items-center justify-center active:scale-90 transition-transform">
            <MapPin size={18} className="text-[#2f8bff]" />
          </button>
          <button onClick={() => navigate('/shop')} className="w-9 h-9 rounded-full bg-[#141c28] flex items-center justify-center active:scale-90 transition-transform">
            <ShoppingBag size={18} className="text-[#2f8bff]" />
          </button>
          <button onClick={() => navigate('/moments')} className="w-9 h-9 rounded-full bg-[#141c28] flex items-center justify-center active:scale-90 transition-transform">
            <Sparkles size={18} className="text-[#c4ccd8]" />
          </button>
        </div>
      </header>
    );
  }

  if (pathname === '/moments') {
    return (
      <header className="shrink-0 flex items-center justify-between px-4 py-3 bg-[#0a0f18] border-b border-[#141c28]">
        <div>
          <h1 className="font-display text-lg font-bold text-white">Moments</h1>
          <p className="text-[11px] text-[#8b95a5]">From people you follow</p>
        </div>
        <button className="w-9 h-9 rounded-full bg-[#141c28] flex items-center justify-center active:scale-90 transition-transform">
          <Shuffle size={17} className="text-[#2f8bff]" />
        </button>
      </header>
    );
  }

  const title = pathname === '/chats' ? 'Chats' : pathname === '/alerts' ? 'Alerts' : pathname === '/shop' ? 'Shop' : pathname === '/places' ? 'Places Nearby' : '';
  return (
    <header className="shrink-0 flex items-center justify-center px-4 py-3.5 bg-[#0a0f18] border-b border-[#141c28] relative">
      <h1 className="font-display text-lg font-bold text-white">{title}</h1>
      <button className="absolute right-4 active:scale-90 transition-transform">
        <MoreVertical size={20} className="text-[#c4ccd8]" />
      </button>
    </header>
  );
}

function AppInner() {
  const { pathname } = useLocation();
  const [createOpen, setCreateOpen] = useState(false);
  const isChatConvo = pathname.startsWith('/chats/');

  return (
    <div className="w-full max-w-[440px] mx-auto h-[100dvh] flex flex-col bg-[#05070c] relative overflow-hidden md:shadow-2xl md:shadow-black/50">
      <TopBar />

      <main className={`flex-1 min-h-0 ${isChatConvo ? 'overflow-hidden' : 'overflow-y-auto app-scroll'}`}>
        <Routes>
          <Route path="/" element={<HomeFeed />} />
          <Route path="/moments" element={<Moments />} />
          <Route path="/chats" element={<Chats />} />
          <Route path="/chats/:id" element={<ChatConversation />} />
          <Route path="/alerts" element={<Alerts />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/places" element={<Places />} />
        </Routes>
      </main>

      {!isChatConvo && <BottomNav onCreate={() => setCreateOpen(true)} />}

      <CreateModal open={createOpen} onClose={() => setCreateOpen(false)} />
      <SafetyGate />
    </div>
  );
}

function App() {
  return (
    <div className="App min-h-[100dvh] bg-[#05070c]">
      <SafetyProvider>
        <BrowserRouter>
          <AppInner />
        </BrowserRouter>
      </SafetyProvider>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
